import { ImMagicWand } from "react-icons/im"
import { Button, Modal, Nav, Spinner } from "react-bootstrap"
import { useEffect, useState, lazy, Suspense } from "react"
import { Link, useLocation } from "react-router-dom"
import { FaTachometerAlt, FaLink, FaRss, FaCog, FaRegBell, FaRegFileAlt, FaGlobe, FaMagic } from "react-icons/fa"
import { GiPartyPopper } from "react-icons/gi";
import { BiBarChartAlt2, BiBuilding, BiMouse, BiNetworkChart, BiSolidMagicWand } from "react-icons/bi"
import { BsFileEarmarkText, BsNewspaper } from "react-icons/bs"
import TransactionReport from "./transaction-report/transaction-report"
import { useAuth } from "../../auth/auth-context"
import ReferenceReport from "./reference-report/reference-report"
import PublisherReport from "./publisher-report/publisher-report"
import CampaignReport from "./campaign-report/campaign-report"
import Feed from "./feed/feed"
import NetworkSettings from "./network-settings/network-settings"
import LinkBuilder from "./link-builder/link-builder"
import Alerts from "./alerts/alerts"
import ScheduledReports from "./scheduled-reports/scheduled-reports"
import { useAppContext } from "../../AppContext"
import ClickReport from "./click-report/click-report"
import EBPristjek from "./eb-pristjek/eb-pristjek"
import LinkScript from "./link-script/link-script";

const Home = lazy(() => import("./home/home"))

export function Dashboard() {
    const loc = useLocation()
    const { user } = useAuth()
console.log(user)
    const {isPdf} = useAppContext()
    const isPublisher = user?.kind === "publisher"
    const [activeTab, setActiveTab] = useState<string>("/")
    // const [showInfoModal, setShowInfoModal] = useState(false)
    // const handleClose = () => setShowInfoModal(false)
    // const handleShow = () => setShowInfoModal(true)

    useEffect(() => {
    const { pathname } = loc

    if (pathname === "/" || pathname.startsWith("/d/")) {
        setActiveTab("/")
    } else if (pathname.startsWith("/link-script")) {
        setActiveTab("/link-script")
    } else {
        setActiveTab(pathname)
    }
    }, [loc])

    const handleSelect = (selectedKey: any) => {
        setActiveTab(selectedKey)
    }
    

    return (
        <div className="d-sm-flex">
            <Nav
                variant="pills"
                className={`flex-column mt-2 mx-2 rounded-3 bg-light-subtle d-none ${isPdf ? '' : 'd-md-flex'}`}
                style={{ width: "240px", minWidth: "240px", height: "calc(100vh - 150px)", position: "relative" }}
                onSelect={handleSelect}
                activeKey={activeTab}
            >
                <Nav.Link as={Link} to="/" eventKey="/" className="text-dark d-flex align-items-center">
                    <FaTachometerAlt className="me-2" /> Dashboard
                </Nav.Link>

                <Nav.Item className="mt-3 mb-1 ps-2 text-muted" style={{ fontSize: "0.7rem", fontWeight: "bold" }}>
                    Reports
                </Nav.Item>
                <Nav.Link as={Link} to="/transaction-report" eventKey="/transaction-report" className="text-dark d-flex align-items-center">
                    <BsFileEarmarkText className="me-2" /> Transaction report
                </Nav.Link>
                {isPublisher && (
                    <Nav.Link as={Link} to="/reference-report" eventKey="/reference-report" className="text-dark d-flex align-items-center">
                        <BiNetworkChart className="me-2" /> Reference report
                    </Nav.Link>
                )}
                {!isPublisher && (
                    <Nav.Link as={Link} to="/publisher-report" eventKey="/publisher-report" className="text-dark d-flex align-items-center">
                        <BiBuilding className="me-2" /> Publisher report
                    </Nav.Link>
                )}
                <Nav.Link as={Link} to="/campaign-report" eventKey="/campaign-report" className="text-dark d-flex align-items-center">
                    <BiBarChartAlt2 className="me-2" /> Campaign report
                </Nav.Link>
                <Nav.Link as={Link} to="/click-report" eventKey="/click-report" className="text-dark d-flex align-items-center">
                    <BiMouse className="me-2" /> Click report
                </Nav.Link>

                <Nav.Item className="mt-3 mb-1 ps-2 text-muted" style={{ fontSize: "0.7rem", fontWeight: "bold" }}>
                    Tools
                </Nav.Item>
                {isPublisher && user?.byClick?.enabled && (
                        <Nav.Link
                            as={Link}
                            to="/link-script"
                            eventKey="/link-script"
                            className="text-dark d-flex align-items-center"
                        >
                            <ImMagicWand className="me-2" style={{ transform: "scaleX(-1)" }} /> Link automation
                        </Nav.Link>
                )}
                {isPublisher && (
                    <Nav.Link as={Link} to="/link-builder" eventKey="/link-builder" className="text-dark d-flex align-items-center">
                        <FaLink className="me-2" /> Link builder
                    </Nav.Link>
                )}
                {!(user as any)?.feed?.disabled && (
                <Nav.Link as={Link} to="/feed-management" eventKey="/feed-management" className="text-dark d-flex align-items-center">
                    <FaRss className="me-2" /> Feed management
                </Nav.Link>
                )}
                        <Nav.Link as={Link} to="/scheduled-reports" eventKey="/scheduled-reports" className="text-dark d-flex align-items-center">
                            <FaRegFileAlt className="me-2" /> Scheduled Reports
                        </Nav.Link> 
                        {!isPublisher && (
                        <>
                        <Nav.Link as={Link} to="/alerts" eventKey="/alerts" className="text-dark d-flex align-items-center">
                            <FaRegBell className="me-2" />
                            Alerts
                        </Nav.Link>
                    </>
                )}
                {user?.isAdmin && (
                    <>
                        <Nav.Item className="mt-3 mb-1 ps-2 text-muted" style={{ fontSize: "0.7rem", fontWeight: "bold" }}>
                            Admin
                        </Nav.Item>
                        <Nav.Link as={Link} to="/eb-pristjek" eventKey="/eb-pristjek" className="text-dark d-flex align-items-center">
                            <BsNewspaper className="me-2" /> EB Pristjek
                        </Nav.Link>
                    </>
                )}
                <Nav.Link as={Link} to="/network-settings" eventKey="/network-settings" className="text-dark d-flex align-items-center mt-auto">
                    <FaCog className="me-2" /> Network settings
                </Nav.Link>
            </Nav>

            <div className={`flex-grow-1 ${isPdf ? 'mt-0' : 'mt-2'}`}>
                <Suspense fallback={<Spinner animation="border" />}>
                    {activeTab === "/" || activeTab.startsWith("/d/") ? (
                        <Home />
                    ) : activeTab === "/transaction-report" ? (
                        <TransactionReport />
                    ) : activeTab === "/reference-report" ? (
                        <ReferenceReport />
                    ) : activeTab === "/publisher-report" ? (
                        <PublisherReport />
                    ) : activeTab === "/campaign-report" ? (
                        <CampaignReport />
                    ) : activeTab === "/click-report" ? (
                        <ClickReport />
                    ) : activeTab === "/alerts" ? (
                        <Alerts />
                    ) : activeTab === "/feed-management" ? (
                        <Feed />
                    ) : activeTab === "/network-settings" ? (
                        <NetworkSettings />
                    ) : activeTab === "/link-script" ? (
                        <LinkScript />
                    ) : activeTab === "/link-script/settings" ? (
                        <LinkScript />
                    ) : activeTab === "/link-builder" ? (
                        <LinkBuilder />
                    ) : activeTab === "/scheduled-reports" ? (
                        <ScheduledReports />
                    ) : activeTab === '/eb-pristjek' ?(
                        <EBPristjek />
                    ) : (
                        "Not found"
                    )}
                </Suspense>
            </div>
        </div>
    )
}
